import { BreadAccount, BreadInstitution } from "breadcommon";
import { useContext } from "react";
import { InstitutionsContext } from "../firebaseio/InstitutionsContext";

export function useInstitutionFromAccount(
  account: BreadAccount | undefined | null,
): BreadInstitution | null | undefined {
  const institutions = useContext(InstitutionsContext);

  if (!account) {
    return null;
  }

  if (
    account.institution_id !== null &&
    institutions.has(account.institution_id)
  ) {
    return institutions.get(account.institution_id);
  }
  return null;
}
